module.exports = __webpack_public_path__ + "img/logo-LM-EQUIPEMENT.f4271626.svg";